import { SVGProps } from "react"

const Rooms2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.51797 2.36713L3.0263 5.86713C2.2763 6.45046 1.66797 7.69213 1.66797 8.63379V14.8088C1.66797 16.7421 3.24297 18.3255 5.1763 18.3255H14.8263C16.7596 18.3255 18.3346 16.7421 18.3346 14.8171V8.75046C18.3346 7.74213 17.6596 6.45046 16.8346 5.87546L11.6846 2.26713C10.518 1.45046 8.64297 1.49213 7.51797 2.36713Z"
      stroke={props.color || "#292D32"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 15H11.25C12.625 15 13.75 13.875 13.75 12.5V10C13.75 8.625 12.625 7.5 11.25 7.5H8.75C7.375 7.5 6.25 8.625 6.25 10V12.5C6.25 13.875 7.375 15 8.75 15Z"
      stroke={props.color || "#292D32"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V15"
      stroke={props.color || "#292D32"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 11.25H13.75"
      stroke={props.color || "#292D32"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Rooms2Icon
